(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ssp-entiat-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ssp-entiat-gallery')) customElements.define('ssp-entiat-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    const groups = [...this.querySelectorAll('[data-photo-group]')];
    const showVariant = variant => {
      if (!variant) return;
      groups.forEach(group => {
        const show = group.dataset.frame === variant.option1 && group.dataset.lens === variant.option2;
        if (!group.hidden && !show) group.querySelectorAll('video').forEach(video => video.pause());
        group.hidden = !show;
      });
    };
    this.setActiveMedia = showVariant;
    this.unsubscribe = window.MinimogEvents?.subscribe(`${this.dataset.productId}__VARIANT_CHANGE`, showVariant);
    const form = this.closest('.sf-product-wrapper')?.querySelector('.main-product-form');
    form?.addEventListener('change', () => requestAnimationFrame(() => showVariant(variants.find(v => String(v.id) === form.querySelector('[name="id"]')?.value))));
    const dialog = this.querySelector('dialog');
    const zoomImage = dialog.querySelector('img');
    this.addEventListener('click', event => {
      const photo = event.target.closest('[data-photo-src]');
      if (photo) {
        zoomImage.src = photo.dataset.photoSrc;
        zoomImage.alt = photo.querySelector('img').alt;
        dialog.showModal();
      }
      if (event.target.closest('[data-ssp-close]') || event.target === dialog) dialog.close();
      const direction = event.target.closest('[data-photo-direction]');
      if (direction) {
        const track = this.querySelector('[data-photo-group]:not([hidden]) .ssp-entiat-photos');
        track?.scrollBy({left:track.clientWidth * Number(direction.dataset.photoDirection),behavior:'smooth'});
      }
    });
  }
  disconnectedCallback() { this.unsubscribe?.(); }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ssp-lens-advisor-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ssp-lens-advisor')) {
  class SSPLensAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.templates = [...this.querySelectorAll('template[data-ssp-tint]')];
      this.select = this.querySelector('[data-ssp-tint-select]');
      this.result = this.querySelector('[data-ssp-result]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-ssp-tint-select],[data-ssp-condition]')) this.show(event.target.value);
      }, options);
      this.addEventListener('toggle', event => {
        if (event.target.matches('.ssp-la-demo') && !event.target.open) event.target.querySelector('video')?.pause();
      }, { ...options, capture: true });
      if (this.dataset.mode === 'product') {
        this.scope = this.closest('[data-variant-picker]');
        this.scope?.addEventListener('change', event => {
          const field = event.target.closest('[data-option-name]');
          if (field && /lens/i.test(field.dataset.optionName)) this.show(event.target.value);
        }, options);
        const field = [...(this.scope?.querySelectorAll('[data-option-name]') || [])].find(el => /lens/i.test(el.dataset.optionName));
        this.show(field?.querySelector('input:checked,select')?.value || field?.dataset.selectedValue || 'clear');
      } else {
        this.show(this.select.value);
      }
      if (this.dataset.mode === 'customizer') {
        this.scope = this.closest('.customize-addonpage');
        this.decorate();
        this.scope?.addEventListener('click', event => {
          const trigger = event.target.closest('[data-ssp-lens-trigger]');
          if (trigger) {
            this.show(trigger.dataset.sspLensTrigger);
            this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
            return;
          }
          const card = event.target.closest('.addonboxes:not(.new)');
          if (card && event.target.closest('.customboximg,.prodname,.addtocart-custom,.addtocart-lens')) this.show(this.cardName(card));
        }, options);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.result?.querySelectorAll('video').forEach(video => video.pause());
      this.ready = false;
    }
    normalize(value) { return String(value || '').split(' / ').pop().toLowerCase().replace(/[^a-z0-9]/g, ''); }
    find(value) {
      const key = this.normalize(value);
      return this.templates.find(t => t.dataset.sspTint === key || t.dataset.aliases.split(',').includes(key));
    }
    cardName(card) {
      return card.querySelector('[color]')?.getAttribute('color') || card.querySelector('.prodname')?.textContent.trim() || '';
    }
    decorate() {
      const label = this.getAttribute('data-details-label') || this.querySelector('.ssp-la-link')?.textContent || 'Tint details';
      this.scope?.querySelectorAll('.addonboxes:not(.new)').forEach(card => {
        if (card.querySelector('[data-ssp-lens-trigger]')) return;
        const match = this.find(this.cardName(card));
        if (!match) return;
        const sourceImage = match.content.querySelector('.ssp-la-media img');
        const cardImage = card.querySelector('.customboximg img');
        if (sourceImage && cardImage) {
          cardImage.src = sourceImage.src;
          cardImage.alt = sourceImage.alt;
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ssp-tint-details';
        button.dataset.sspLensTrigger = match.dataset.sspTint;
        button.textContent = label;
        button.setAttribute('aria-label', label + ': ' + match.content.querySelector('h3').textContent);
        card.append(button);
      });
    }
    show(value) {
      const template = this.find(value);
      if (!template) return;
      if (this.dataset.selectedTint === template.dataset.sspTint) return;
      this.result.querySelectorAll('video').forEach(video => video.pause());
      this.result.replaceChildren(template.content.cloneNode(true));
      if (this.select) this.select.value = template.dataset.sspTint;
      this.dataset.selectedTint = template.dataset.sspTint;
      const condition = this.querySelector('[data-ssp-condition]');
      if (condition && condition.value !== template.dataset.sspTint) condition.value = '';
    }
  }
  customElements.define('ssp-lens-advisor', SSPLensAdvisor);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ssp-purchase-points"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ssp-policy-summary')) customElements.define('ssp-policy-summary', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const dialog = this.querySelector('dialog');
    this.querySelector('.ssp-policy-trigger').addEventListener('click', () => dialog.showModal());
    this.querySelector('[data-ssp-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  }
});
  } catch(e) { console.error(e); }
})();

})();
